import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { useUserInfo } from '../../contexts/user-context/use-user-info';

const VerifyEmail = () => {
  const [isResending, setIsResending] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const navigate = useNavigate();
  const { isAuthenticated, authenticatedInfo, mutations } = useUserInfo();

  useEffect(() => {
    if (authenticatedInfo?.emailVerified) {
      navigate('/signup/organisation');
    }
  }, [authenticatedInfo?.emailVerified, navigate]);

  const resendVerificationEmail = async () => {
    if (!isAuthenticated || !authenticatedInfo) {
      return;
    }

    try {
      const response = await fetch(`/api/users/me/resend-verification-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        toast.success('We have sent you an email. Please check your inbox.');
      } else {
        throw new Error('Failed to resend verification email');
      }
    } catch {
      toast.error('There was a problem sending the verification email');
    }
  };

  const handleResend = async () => {
    setIsResending(true);

    await resendVerificationEmail();

    setResendTimer(52); // Start the countdown timer
    const timer = setInterval(() => {
      setResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsResending(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  return (
    <div className="mt-8 text-center">
      <h2 className="mb-4 text-2xl font-bold">Verify Your Email</h2>
      <p className="mb-4 text-gray-600">
        We've sent a verification link to <strong>{authenticatedInfo?.email}</strong>. Please check your inbox and click
        the link to verify your email.
      </p>
      <p className="mb-6 text-gray-600">
        Once you've verified your email, you'll be automatically redirected to the next step.
      </p>
      <div className="text-center">
        <p className="mb-2 text-sm text-gray-500">
          {isResending ? `Resending email... ${resendTimer}s` : "Didn't receive the verification email?"}
        </p>
        <button
          onClick={handleResend}
          disabled={isResending}
          className="rounded bg-primary px-4 py-2 font-bold text-black hover:bg-primary-dark disabled:opacity-50"
        >
          Resend Verification Email
        </button>
      </div>
      <div className="mt-4 text-center">
        <p className="text-sm text-gray-500">
          Not {authenticatedInfo?.email}?{' '}
          <button onClick={mutations.logout} className="text-primary hover:text-primary-dark">
            Click here to log out
          </button>
        </p>
      </div>
    </div>
  );
};

export default VerifyEmail;
